import { useLocation } from 'react-router';
import { useSlots } from '@gonfalon/react/useSlots';
import { Tab, TabList, TabPanel, Tabs } from '@launchpad-ui/components';

import styles from './SettingsCardTabs.module.css';

export function SettingsCardTab({ children, ...props }: React.ComponentProps<typeof Tab>) {
  return (
    <Tab className={styles.tab} id={`${props.href}`} key={`${props.href}`} href={props.href} {...props}>
      {children}
    </Tab>
  );
}

export function SettingsCardTabPanel({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();

  return (
    <TabPanel id={pathname} className={styles.tabPanel}>
      {children}
    </TabPanel>
  );
}

export function SettingsCardTabs({
  children,
  ...props
}: React.ComponentProps<typeof Tabs> & { children: React.ReactNode }) {
  const [slots, restChildren] = useSlots(children, {
    tabPanel: SettingsCardTabPanel,
  });
  const { pathname } = useLocation();

  return (
    <Tabs selectedKey={pathname} className={styles.tabs} {...props}>
      <TabList className={styles.tabList}>{restChildren}</TabList>
      {slots.tabPanel}
    </Tabs>
  );
}
